import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { PlaceholderBox } from '../../../../../../shared/components/ui/PlaceholderBox'
import { ErrorBox } from '../../../../../../shared/components/ui/ErrorBox'
import { recurringPaymentsProxy, TableColumnsEnum } from '../../recurringPaymentsProxy'
import { RecurringPaymentsTableHeader } from './components/RecurringPaymentsTableHeader'
import { RecurringPaymentsTableFooter } from './components/RecurringPaymentsTableFooter'
import { RecurringPaymentsRows } from './components/RecurringPaymentsRows/RecurringPaymentRows'

export function RecurringPaymentsTable (): ReactElement {
  const { apiCall } = useSnapshot(recurringPaymentsProxy)
  return (
    <div className="w-full">
      <PlaceholderBox loading={apiCall.loading} rows={20} additionalClasses="p-2">

        <table className="w-full">
          <thead className="text-left">
            <tr>
              <RecurringPaymentsTableHeader title="Id" width={10} sortColumn={TableColumnsEnum.RecurringPaymentId} />
              <RecurringPaymentsTableHeader title="Company" width={10} sortColumn={TableColumnsEnum.CompanyName} />
              <RecurringPaymentsTableHeader title="Name" width={10} sortColumn={TableColumnsEnum.CustomerName} />
              <RecurringPaymentsTableHeader title="Invoice Number" width={10} sortColumn={TableColumnsEnum.InvoiceNumber} />
              <RecurringPaymentsTableHeader title="Status" width={10} sortColumn={TableColumnsEnum.Status} />
              <RecurringPaymentsTableHeader title="Frequency" width={10} sortColumn={TableColumnsEnum.BillingCycle} />
              <RecurringPaymentsTableHeader title="Amount" width={10} sortColumn={TableColumnsEnum.Amount} />
              <RecurringPaymentsTableHeader title="Last Payment Date" width={10} sortColumn={TableColumnsEnum.LastUpdatedDate} />
              <RecurringPaymentsTableHeader title="Next Payment Date" width={10} sortColumn={TableColumnsEnum.NextPaymentDate} />
            </tr>
          </thead>
          <ErrorBox error={apiCall.error}>
            <tbody>
              <RecurringPaymentsRows />
            </tbody>
          </ErrorBox>
        </table>
        <hr />
        <RecurringPaymentsTableFooter />

      </PlaceholderBox>
    </div>

  )
}
